
import React from "react";
import { IScoreboard } from "../../../../services/api/Scoreboard";
import Formatter from "../../../../services/utils/Formatter";
import OdometerCounter from "react-odometerjs";
import "./assets/css/odometer.css";

interface OdometerProps {
    score: IScoreboard;
    scoreYtd: IScoreboard;
    actual: string;
    cre: string;
    date: Date;
    useHeader?: Boolean;
    isCountry?: Boolean;
    onUpdate?: Function;
}

const Odometer: React.FC<OdometerProps> = ({ score, scoreYtd, actual, cre, date, useHeader = true, isCountry, onUpdate }) => {
    const value = score.actual ?? 0;
    const valueCRE = Math.max(1,
        cre === "BP" ? score.planBusinessPlan :
            cre === "SRE" ? score.planSRE :
                score.planFRE);


    const ytdValue = scoreYtd.actual ?? 0;
    const ytdValueCRE = Math.max(1,
        cre === "BP" ? scoreYtd.planBusinessPlan :
            cre === "SRE" ? scoreYtd.planSRE :
                scoreYtd.planFRE);

    const odometerValue = normalizeNumber(Math.round(value));
    const Percent = (value / valueCRE - 1) * 100;
    
    const YTDPercent = (ytdValue / ytdValueCRE - 1) * 100;

    onUpdate && onUpdate(value, ((value / valueCRE - 1)  * 100));

    function FormatValues(value: Number) {
        let s: string = value.toString();
        while (s.length < 9) s = "0" + s;
        return s.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }

    function GetProgressBar(value: number) {
        value += 100

        return (
            <span
                className={
                    "bar " + (value <= 50 ? "red" : value >= 100 ? "green" : "yellow")
                }
                style={{ width: value + "%" }}
            ></span>
        );
    }
    function normalizeNumber(value: number) {
        let s: string = value.toString();
        while (s.length < 9) s = "0" + s;
        return parseInt("1" + s);
    }

    function getDuration(time: number) {
        return (
            "#od" +
            score.code +
            " .odometer.odometer-auto-theme.odometer-animating-up .odometer-ribbon-inner, " +
            "#od" +
            score.code +
            " .odometer.odometer-theme-minimal.odometer-animating-up .odometer-ribbon-inner," +
            "#od" +
            score.code +
            " .odometer.odometer-auto-theme.odometer-animating-down.odometer-animating .odometer-ribbon-inner, .odometer.odometer-theme-minimal.odometer-animating-down.odometer-animating .odometer-ribbon-inner {" +
            "-webkit-transition-duration: " +
            time +
            "s !important;" +
            "-moz-transition-duration: " +
            time +
            "s !important;" +
            "-ms-transition-duration: " +
            time +
            "s !important;" +
            "-o-transition-duration: " +
            time +
            "s !important;" +
            "transition-duration: " +
            time +
            "s !important" +
            "}"
        );
    }

    return (
        <div
            className={isCountry ? "country" : "totalCount"}
            id={"od" + score.code}
        >
            <style>{getDuration(1.25)}</style>
            {useHeader ? (
                <div className="header">
                    <h2>{score.name}</h2>
                    <OdometerCounter
                        value={odometerValue}
                        minIntegerLen={9}
                        //duration={Step * 5}
                        //animation="count"
                        format="(.ddd)"
                    />
                </div>
            ) : (
                <OdometerCounter
                    value={odometerValue}
                    minIntegerLen={9}
                    //duration={Step * 5}
                    format="(.ddd)"
                />
            )}

            <div className="grid grid-2">
                <div className="box">
                    <h2>ACTUAL</h2>
                    <div className="barContainer">{GetProgressBar(Percent)}</div>
                    <div className="numbers">
                        <span className="count">{FormatValues(valueCRE)}</span>
                        <span className="percent">
                            {Formatter.DisplayPercent(Percent)}<br /> <span>vs {cre}</span>
                        </span>
                    </div>
                </div>
                <div className="box">
                    <h2>ACTUAL YTD</h2>
                    <div className="barContainer"> {GetProgressBar(YTDPercent)} </div>
                    <div className="numbers">
                        <span className="count">{FormatValues(ytdValueCRE)}</span>
                        <span className="percent">
                            {Formatter.DisplayPercent(YTDPercent)}<br /> <span>vs {cre}</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Odometer;
